import script from "./FvContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FvContent.vue?vue&type=script&setup=true&lang=js"

import "./FvContent.vue?vue&type=style&index=0&id=494af6db&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-494af6db"]])

export default __exports__